export const MyConst = {
  URLASET: process.env.REACT_APP_URLASET,
  URLAPI: process.env.REACT_APP_URLAPI,
  BASEURL: process.env.REACT_APP_URL,
  BASENAME: process.env.REACT_APP_BASENAME,
  SYS_NAME: process.env.REACT_APP_INDEX_TITLE || "Sistem Informasi Manajemen Keolahragaan (SIMAKOR)",
  SYS_SHORT_NAME: process.env.REACT_APP_SHORT_NAME || "SIMAKOR",
  SYS_OWNER_NAME: process.env.REACT_APP_OWNER_NAME || "KONI Kabupaten Kutai Timur",
  PER_PAGE: 20,
  MAX_PAGE_VIEW: 5,
  ENABLE_REGISTRATION: false,
  ENABLE_FORGOT_PASSWORD: false,
  CLASS_BUTTON_COLOR: "btn-primary",
  THEME_MODE: "hold-transition sidebar-mini layout-fixed",
  THEME_MODE_CSS: "/assets/dist/css/adminlte.min.css",
  PAPER_ORIENTATION: "p",
  PAPER_SIZE: "letter",
  VERSION: "v.1.07",
  BOOTSTRAP_SCHEMA_VERSION: "2026-09-17.3",
  LOGO_FILE: "/logo.png",
  LOADING_FILE: "/loading.png",
  WEB: "ui.medialengka.com",
  PDF_HEADER_1: "KOMITE OLAHRAGA NASIONAL INDONESIA",
  PDF_HEADER_2: "SISTEM MANAJEMEN KEOLAHRAGAAN",
  PDF_HEADER_3: "SIMAKOR",
  ALAMAT: "Alamat sekretariat disesuaikan dengan organisasi pengguna",
  PHONE: "-",
  EMAIL: "-",
};
